import EndLineDispatch from "../../../components/DispatchCentre/EndLineDispatch";

const DispatchCentrePage =({userData})=>{
    return(
        <div>
        <EndLineDispatch userData={userData}/>
        </div>
    )
};

export default DispatchCentrePage;